__turbopack_context__.v({
  "confirmationDrawCountdown": "ConfirmationDrawCountdown-module__atDWfq__confirmationDrawCountdown",
  "content": "ConfirmationDrawCountdown-module__atDWfq__content",
  "countdown": "ConfirmationDrawCountdown-module__atDWfq__countdown",
  "countdownImageContainer": "ConfirmationDrawCountdown-module__atDWfq__countdownImageContainer",
  "countdownImageWrapper": "ConfirmationDrawCountdown-module__atDWfq__countdownImageWrapper",
});
